import { Typography } from '@mui/material';

import { BASE_URL } from '../../services/ADapi';

import styles from './Header.module.scss';

import { useGetAuthenticationQuery } from '../../services/ADapi';

const Header = () => {
  const { data: { permissions, username, is_authenticated } = {} } =
    useGetAuthenticationQuery();

  return (
    <header className={styles['header']}>
      <div className={styles['header-controls']}>
        {permissions?.is_staff && (
          <a
            href={`${BASE_URL}/you-were-never-here/`}
            className={styles['header-controls-dashboard']}
          >
            {' '}
          </a>
        )}
        <Typography variant="username" component="span">
          {username}
        </Typography>
        {is_authenticated ? (
          <a
            href={`${BASE_URL}/auth/logout/`}
            className={styles['header-controls-logout']}
          >
            {' '}
          </a>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
